/* =========================================================================
   LP B2B "Seja um Lojista Guday"  —  NOVO LAYOUT (v2)  —  JS escopado
   - Chips (checkbox toggle + radio single-select) com marcador circular
   - Máscara de CNPJ + autopreenchimento via BrasilAPI (só campos vazios)
   - Submit -> POST no Apps Script (no-cors) + estado de sucesso
   - Acordeão FAQ + smooth-scroll (prontos pras seções das próximas rodadas)
   Bootstrap em DOMContentLoaded + shopify:section:load (theme editor).
   ========================================================================= */
(function () {
  function init(root) {
    if (!root || root.dataset.lpb2b2Init === '1') return;
    root.dataset.lpb2b2Init = '1';

    /* ============== FAQ ACCORDION ==============
       Classe `open` + max-height: scrollHeight (igual ao mockup). Accordion
       exclusivo: abrir um fecha os demais. */
    root.querySelectorAll('.lp-b2b2-faq-item').forEach(function (item) {
      var q = item.querySelector('.lp-b2b2-faq-q');
      var a = item.querySelector('.lp-b2b2-faq-a');
      if (!q || !a) return;
      q.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');
        root.querySelectorAll('.lp-b2b2-faq-item.open').forEach(function (o) {
          if (o !== item) {
            o.classList.remove('open');
            var oa = o.querySelector('.lp-b2b2-faq-a');
            if (oa) oa.style.maxHeight = '0';
            var ob = o.querySelector('.lp-b2b2-faq-q');
            if (ob) ob.setAttribute('aria-expanded', 'false');
          }
        });
        item.classList.toggle('open', !isOpen);
        a.style.maxHeight = !isOpen ? a.scrollHeight + 'px' : '0';
        q.setAttribute('aria-expanded', String(!isOpen));
      });
    });

    /* ============== SMOOTH SCROLL CTAs -> FORM ============== */
    root.querySelectorAll('[data-lp-scroll]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href') || '';
        if (href.charAt(0) !== '#') return;
        var target = root.querySelector(href);
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    /* ============== FORM CHIPS (toggle visual + single-select radios) ============== */
    root.querySelectorAll('.lp-b2b2-chip').forEach(function (chip) {
      var input = chip.querySelector('input');
      if (!input) return;
      function sync() {
        if (input.type === 'radio') {
          root.querySelectorAll('input[name="' + input.name + '"]').forEach(function (sib) {
            var lbl = sib.closest('.lp-b2b2-chip');
            if (lbl) lbl.classList.toggle('lp-b2b2-on', sib.checked);
          });
        } else {
          chip.classList.toggle('lp-b2b2-on', input.checked);
        }
      }
      input.addEventListener('change', sync);
      sync();
    });

    /* ============== CNPJ MASK + VALIDAÇÃO + AUTOPREENCHIMENTO (BrasilAPI, sem backend) ============== */
    var cnpj = root.querySelector('input[name="cnpj"]');
    var cnpjMsg = cnpj && cnpj.parentNode.querySelector('.lp-b2b2-cnpj-msg');

    /* máscara robusta: monta 00.000.000/0000-00 a partir dos dígitos limpos (nunca quebra) */
    function maskCNPJ(digits) {
      var d = digits.slice(0, 14);
      var out = '';
      if (d.length > 0) out = d.slice(0, 2);
      if (d.length >= 3) out += '.' + d.slice(2, 5);
      if (d.length >= 6) out += '.' + d.slice(5, 8);
      if (d.length >= 9) out += '/' + d.slice(8, 12);
      if (d.length >= 13) out += '-' + d.slice(12, 14);
      return out;
    }

    /* validação de dígito verificador (CNPJ matematicamente válido) */
    function isValidCNPJ(d) {
      if (d.length !== 14 || /^(\d)\1{13}$/.test(d)) return false;
      function calc(base) {
        var pesos = base.length === 12
          ? [5,4,3,2,9,8,7,6,5,4,3,2]
          : [6,5,4,3,2,9,8,7,6,5,4,3,2];
        var soma = 0;
        for (var i = 0; i < base.length; i++) soma += parseInt(base[i], 10) * pesos[i];
        var r = soma % 11;
        return r < 2 ? 0 : 11 - r;
      }
      var dv1 = calc(d.slice(0, 12));
      var dv2 = calc(d.slice(0, 12) + dv1);
      return d.slice(12) === '' + dv1 + dv2;
    }

    function setCnpjMsg(text, kind) {
      if (!cnpjMsg) return;
      cnpjMsg.textContent = text || '';
      cnpjMsg.classList.toggle('is-show', !!text);
      cnpjMsg.classList.toggle('is-error', kind === 'error');
      cnpjMsg.classList.toggle('is-ok', kind === 'ok');
      cnpj.classList.toggle('lp-b2b2-invalid', kind === 'error');
      cnpj.classList.toggle('lp-b2b2-cnpj-valid', kind === 'ok');
    }

    /* feedback progressivo, estilo Caffeine: só mostra "inválido" quando completa 14 dígitos */
    function validateCNPJ(showIncomplete) {
      var d = (cnpj.value || '').replace(/\D/g, '');
      if (d.length === 0) { setCnpjMsg('', null); return false; }
      if (d.length < 14) {
        setCnpjMsg(showIncomplete ? 'CNPJ deve ter 14 dígitos' : '', showIncomplete ? 'error' : null);
        return false;
      }
      if (!isValidCNPJ(d)) { setCnpjMsg('CNPJ ' + maskCNPJ(d) + ' inválido.', 'error'); return false; }
      setCnpjMsg('CNPJ válido ✓', 'ok');
      return true;
    }

    if (cnpj) {
      cnpj.addEventListener('input', function () {
        var d = cnpj.value.replace(/\D/g, '').slice(0, 14);
        cnpj.value = maskCNPJ(d);
        /* enquanto digita: não acusa "incompleto" (menos agressivo); valida ao completar 14 */
        if (d.length === 14) {
          if (validateCNPJ(false)) buscarCNPJ(cnpj.value);
        } else {
          setCnpjMsg('', null);
        }
      });
      /* no blur: aí sim cobra os 14 dígitos + valida + busca */
      cnpj.addEventListener('blur', function () {
        if (validateCNPJ(true)) buscarCNPJ(cnpj.value);
      });
    }

    var lastCnpj = '';
    var buscando = false;

    function fill(name, value) {
      if (value == null || value === '' || value === '0') return false;
      var el = root.querySelector('input[name="' + name + '"]');
      if (!el || el.value.trim()) return false;
      el.value = value;
      el.classList.remove('lp-b2b2-invalid');
      el.classList.add('lp-b2b2-autofilled');
      setTimeout(function () { el.classList.remove('lp-b2b2-autofilled'); }, 1600);
      return true;
    }

    function buscarCNPJ(raw) {
      var limpo = (raw || '').replace(/\D/g, '');
      if (limpo.length !== 14 || limpo === lastCnpj || buscando) return;
      lastCnpj = limpo;
      buscando = true;
      if (cnpj) cnpj.classList.add('lp-b2b2-loading');

      fetch('https://brasilapi.com.br/api/cnpj/v1/' + limpo)
        .then(function (res) {
          if (!res.ok) throw new Error('cnpj ' + res.status);
          return res.json();
        })
        .then(function (data) {
          fill('loja', data.nome_fantasia || data.razao_social);
          var cepFmt = (data.cep || '').replace(/\D/g, '').replace(/^(\d{5})(\d{3})$/, '$1-$2');
          fill('cep', cepFmt);
          fill('rua', data.logradouro);
          fill('numero', data.numero);
          fill('bairro', data.bairro);
          fill('cidade', data.municipio);
          fill('estado', data.uf);
        })
        .catch(function (e) {
          console.warn('[CNPJ] autopreenchimento indisponível:', e.message);
          lastCnpj = '';
        })
        .then(function () {
          buscando = false;
          if (cnpj) cnpj.classList.remove('lp-b2b2-loading');
        });
    }

    /* ============== SUBMIT -> grava na planilha (Apps Script) + estado de sucesso ============== */
    var card = root.querySelector('.lp-b2b2-form-card');
    var form = card && card.querySelector('.lp-b2b2-form');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var ok = true;
        form.querySelectorAll('input[required]').forEach(function (input) {
          var empty = !input.value.trim();
          input.classList.toggle('lp-b2b2-invalid', empty);
          if (empty && ok) { ok = false; input.focus(); }
        });
        if (!ok) return;

        var submitBtn = form.querySelector('.lp-b2b2-form-submit');
        var endpoint = (form.getAttribute('data-endpoint') || '').trim();

        function showSuccess() {
          card.classList.add('is-success');
          card.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        if (!endpoint) { showSuccess(); return; }

        var btnLabel = submitBtn ? submitBtn.textContent : '';
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.classList.add('lp-b2b2-loading-btn');
          submitBtn.textContent = 'Processando...';
        }
        var payload = collectFormData(form);
        var startedAt = Date.now();
        function finish(done) {
          var elapsed = Date.now() - startedAt;
          var wait = Math.max(0, 600 - elapsed);
          setTimeout(function () {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.classList.remove('lp-b2b2-loading-btn');
              submitBtn.textContent = btnLabel;
            }
            done();
          }, wait);
        }

        fetch(endpoint, {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'text/plain;charset=utf-8' },
          body: JSON.stringify(payload)
        })
          .then(function () { finish(showSuccess); })
          .catch(function (err) {
            console.warn('[lp-b2b2] falha ao enviar lead:', err);
            finish(showSuccess);
          });
      });
      form.querySelectorAll('input').forEach(function (input) {
        input.addEventListener('input', function () { input.classList.remove('lp-b2b2-invalid'); });
      });
    }
  }

  /* Monta o objeto enviado pro Apps Script a partir dos campos do form.
     Mesmo shape do form original (lp-sejaumlojista) pra gravar na mesma planilha. */
  function collectFormData(form) {
    var data = {};
    form.querySelectorAll('input[name]').forEach(function (input) {
      var name = input.name;
      if (input.type === 'checkbox') {
        if (!input.checked) return;
        var key = name.replace(/\[\]$/, '');
        if (!data[key]) data[key] = [];
        data[key].push(input.value);
      } else if (input.type === 'radio') {
        if (input.checked) data[name] = input.value;
      } else {
        data[name] = input.value.trim();
      }
    });
    data.origem = form.getAttribute('data-source') || window.__lpSource || 'lp-sejaumlojista';
    return data;
  }

  function bootstrap() {
    document.querySelectorAll('.lp-b2b2-wrap').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
  document.addEventListener('shopify:section:load', bootstrap);
})();
